import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface BlogPost {
  id: string;
  title: string;
  slug: string;
  short_description: string | null;
  long_description: string | null;
  main_image_url: string | null;
  gallery_images_urls: string[] | null;
  category_id: string | null;
  is_active: boolean;
  is_featured: boolean;
  created_at: string;
  updated_at: string;
  tour_categories?: {
    name: string;
    icon: string;
  };
}

export const useBlogs = () => {
  const [blogs, setBlogs] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const { data, error } = await supabase
        .from('blog_posts')
        .select(`
          *,
          tour_categories (
            name,
            icon
          )
        `)
        .eq('is_active', true)
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching blog posts:', error);
        return;
      }

      setBlogs(data || []);
    } catch (error) {
      console.error('Error fetching blog posts:', error);
    } finally {
      setLoading(false);
    }
  };

  const getFeaturedBlogs = () => {
    return blogs.filter(blog => blog.is_featured);
  };

  const getBlogBySlug = (slug: string) => {
    return blogs.find(blog => blog.slug === slug);
  };

  const getBlogsByCategory = (categoryId: string) => {
    return blogs.filter(blog => blog.category_id === categoryId);
  };

  return { 
    blogs, 
    loading, 
    refetch: fetchBlogs, 
    getFeaturedBlogs, 
    getBlogBySlug,
    getBlogsByCategory
  };
};